export function enemyMatchesTheme(enemy, theme) {
    if (enemy.tags.includes('universal'))
        return true;
    return theme.enemyTags.some((tag) => enemy.tags.includes(tag));
}
/**
 * A target-tier run may reuse the preceding tier as supporting content. This
 * lets a tier-2 dungeon use a known tier-1 gatekeeper while keeping the final
 * boss and most ordinary enemies at the target tier.
 */
export function enemyMatchesTier(enemy, theme, targetTier) {
    const minimum = Math.max(theme.tierRange.min, targetTier - 1);
    const maximum = Math.min(theme.tierRange.max, targetTier);
    return enemy.tier >= minimum && enemy.tier <= maximum;
}
export function eligibleEnemies(enemies, theme, targetTier, boss) {
    return enemies.filter((enemy) => Boolean(enemy.boss) === boss &&
        enemyMatchesTier(enemy, theme, targetTier) &&
        enemyMatchesTheme(enemy, theme));
}
//# sourceMappingURL=eligibility.js.map